import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import * as React from "react";
import { cn } from "~/lib/utils";

const PortalTooltipProvider = TooltipPrimitive.Provider;
const PortalTooltip = TooltipPrimitive.Root;
const PortalTooltipTrigger = TooltipPrimitive.Trigger;

const PortalTooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({ className, sideOffset = 4, ...props }, ref) => (
  <TooltipPrimitive.Portal container={document.body}>
    <TooltipPrimitive.Content
      ref={ref}
      sideOffset={sideOffset}
      className={cn(
        "fixed z-[9999] w-max max-w-[400px] break-words overflow-hidden rounded-md border bg-popover px-3 py-1.5 text-sm text-popover-foreground shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        className,
      )}
      style={{ zIndex: 9999 }}
      {...props}
    />
  </TooltipPrimitive.Portal>
));
PortalTooltipContent.displayName = TooltipPrimitive.Content.displayName;

export {
  PortalTooltip,
  PortalTooltipTrigger,
  PortalTooltipContent,
  PortalTooltipProvider,
};
